import type coreId from "./id";

const coreEn: typeof coreId = {
	menu: {
		dashboard: "Dashboard",
		toko: "Store",
		karyawan: "Employee",
		kategori: "Category",
		produk: "Product",
		inventory: {
			title: "Inventory",
			kartu_stok: "Stock Card",
			stok_masuk: "Stock In",
			stok_keluar: "Stock Out",
			stok_transfer: "Stock Transfer",
			penyesuaian_stok: "Stock Adjustment",
		},
		pelanggan: "Customer",
		sistem_point: "Point System",
		kartu: "Card",
		promo: "Promo",
		cazhbox: "Cazhbox",
		laporan_offline: "Offline Store Report",
		laporan_online: "Online Store Report",
		supplier: "Supplier",
		akun: "Account",
		profil: "Profile",
	},

	dashboard: {
		title: "Dashboard",
		description: "Total Sales & Qty Statistics",
		sales_stats: {
			total: "Total Sales Statistics",
			qty: "Qty Sales Statistics",
			day: "Day",
			filter: {
				store: "All Stores",
				employee: "All Employees",
				date: "Period",
			},
		},
	},

	toko: {
		title: "Store Dashboard",
		description: "Store Data and Information Summary",
		stats: {
			title: {
				products: "Products",
				orders: "Orders",
				customers: "Customers",
				revenue: "Revenue",
			},
			description: {
				products: "Available products",
				orders: "Total orders this month",
				customers: "Number of customers",
				revenue: "Total revenue",
			},
		},
		recent_orders: {
			title: "Recent Orders",
			description: "{count} orders this month",
			view_all: "View All",
		},
		sales_chart: {
			title: "Sales Chart",
			description: "Total sales {period} from {from} to {to}",
			filterPeriod: {
				weekly: "Weekly",
				monthly: "Monthly",
				yearly: "Yearly",
			},
		},
	},

	authentication: {
		check_card: "Check Card",
		login: {
			title: "Login to your account!",
			description:
				"Enter your email address and password to login to the system.",
			google_signin: "Sign in with Google",
		},
		forgot_password: {
			title: "Forgot Password?",
			description: "Enter your email to reset your password.",
			send_password: "Send New Password",
			success_title: "Check Your Email",
			success_description: "A new password has been sent to your email.",
		},
	},

	table: {
		select_all: "Select all",
		selected: "Selected",
		filter: "Filter",
		rows_per_page: "Rows Per Page",
	},

	forms: {
		color: {
			label: "Color",
			placeholder: "Select Color",
			error_message: "Color is required",
		},
		icon: {
			placeholder: "Select Icon",
			error_message: "Icon is required",
		},
		email: {
			label: "Email",
			placeholder: "Enter email",
			error_message: "Email is required",
			invalid_message: "Invalid email format",
		},
		password: {
			label: "Password",
			placeholder: "Enter password",
			error_message: "Password is required",
		},
		school_year: {
			error_message: "School year is required",
		},
		semester: {
			error_message: "Semester is required",
		},
		start_date: {
			error_message: "Start date is required",
		},
		end_date: {
			error_message: "End date is required",
		},
		office: {
			error_message: "Office is required",
		},
		school_level: {
			error_message: "School level is required",
		},
		school_class: {
			error_message: "School class is required",
		},
		major: {
			error_message: "Major is required",
		},
		subject: {
			error_message: "Subject is required",
		},
		tag: {
			error_message: "Tag is required",
		},
		code_tag: {
			error_message: "Tag code is required",
		},
		room: {
			error_message: "Room is required",
		},
		category_event: {
			error_message: "Event category is required",
		},
		combined_schedule: {
			error_message: "Combined schedule is required",
		},
		file: {
			error_message: "File is required",
		},
		start_day: {
			error_message: "Start day is required",
		},
		weekend_name: {
			error_message: "Weekend name is required",
		},
	},

	general: {
		select_file: "Browse File",
		for_upload: "for upload",
		template_upload_description: "Download template for data upload",
		login: "Login",
		back: "Back",
		or: "Or",
		profile: "Profile",
		language: "Language",
		dark_mode: "Dark Mode",
		light_mode: "Light Mode",
		logout: "Logout",
	},

	settings: {
		institution: {
			detail: {
				form: {
					education_level: {
						error_message: "Education level is required",
					},
					pic_phone: {
						error_message: "PIC phone number is required",
					},
					institution_address: {
						error_message: "Institution address is required",
					},
					pic_name: {
						error_message: "PIC name is required",
					},
				},
			},
		},
	},
};

export default coreEn;
